const section = document.querySelector('section.contact-form');
const form = section?.querySelector('.js-cf-form') ?? null;

if (form) {
    const htmlBase = section.getAttribute('data-popup-html');
    const createPopup = res => {
        const { status, status_msg } = res.detail;

        if (status && status_msg) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlBase;

            const popup = tempDiv.querySelector('.popup-contact-form');
            const titleElement = tempDiv.querySelector(
                '.popup-contact-form__heading'
            );
            const iconElement = tempDiv.querySelector(
                '.popup-contact-form__icon'
            );
            if (titleElement) {
                titleElement.textContent = status_msg;
            }

            if (iconElement) {
                iconElement.classList.remove(
                    'icon-check-circle-2',
                    'icon-info'
                );
                popup.classList.remove('-success');
                if (status === 'ERROR') {
                    iconElement.classList.add('icon-info');
                } else {
                    popup.classList.add('-success');
                    iconElement.classList.add('icon-check-circle-2');
                }
            }

            document.dispatchEvent(
                new CustomEvent('mda:popup:open', {
                    detail: {
                        html: tempDiv.innerHTML,
                    },
                })
            );
        }
    };

    form.addEventListener('formSubmitEnd', e => {
        createPopup(e);
    });
}
